import api from './api'

export interface EvaluationCriteria {
  id?: string
  evaluationGridId?: string
  name: string
  description?: string
  coefficient: number
}

export interface EvaluationGrid {
  id: string
  name: string
  classId: string
  academicYear: string
  semester: 'S1' | 'S2'
  criteria: EvaluationCriteria[]
  createdAt: string
  updatedAt: string
}

export interface CreateEvaluationGridDto {
  name: string
  classId: string
  academicYear: string
  semester: 'S1' | 'S2'
  criteria: Omit<EvaluationCriteria, 'id' | 'evaluationGridId'>[]
}

const evaluationGridService = {
  async getAll(): Promise<EvaluationGrid[]> {
    const response = await api.get('/api/grids')
    if (response.grids && Array.isArray(response.grids)) {
      return response.grids
    }
    if (Array.isArray(response)) {
      return response
    }
    return []
  },

  async create(data: CreateEvaluationGridDto): Promise<EvaluationGrid> {
    const response = await api.post('/api/grids', data)
    return response.grid || response
  },

  async getById(id: string): Promise<EvaluationGrid> {
    const response = await api.get(`/api/grids/${id}`)
    return response.grid || response
  },

  async update(id: string, data: Partial<CreateEvaluationGridDto>): Promise<EvaluationGrid> {
    const response = await api.put(`/api/grids/${id}`, data)
    return response.grid || response
  },

  async delete(id: string): Promise<void> {
    await api.delete(`/api/grids/${id}`)
  }
}

export default evaluationGridService
